import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery, useMutation } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';

import Button from '../../../shared/components/ui/Button';
import { getCloseDeals, generateDocument } from '../../services/api/implementation/impl';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

const NewPropertyDocumentModal = ({ onClose, templateId, onSuccess, existingDealIds, projectId: propProjectId }) => {
  const userId = Cookies.get('userId');
  const { id: paramProjectId } = useParams();
  const projectId = propProjectId || paramProjectId;
  const [selectedDealId, setSelectedDealId] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]); // Default to current date
  const [dateOption, setDateOption] = useState('current'); // State for date option

  // Fetch all closed deals
  const {
    data: closeDealsData,
    isLoading: isLoadingCloseDeals,
    isError: isErrorCloseDeals
  } = useQuery({
    queryKey: ['closeDeals'],
    queryFn: getCloseDeals
  });


  console.log("closeDealsData=========", closeDealsData);
  console.log("projectId========", projectId);

  // Filter deals by project ID and exclude existing deals
  const dealsForProject =
    closeDealsData?.data?.filter(
      (deal) => deal?.unit?.project_id === Number(projectId) && !existingDealIds.includes(deal.id)
    ) || [];

  console.log("dealsForProject=========", dealsForProject);

  // Setup mutation to create/generate document
  const { mutate: createDocument, isLoading: isGeneratingDoc } = useMutation({
    mutationFn: (payload) => generateDocument(payload),
    onSuccess: () => {
      toast.success('Document created successfully');
      onSuccess();
    },
    onError: (error) => {
      console.error('Error creating document:', error);
      toast.error(error?.response?.data?.message || error?.message || 'Error creating document');
    }
  });

  // Handle Generate Document button
  const handleGenerateDocument = () => {
    if (!selectedDealId) {
      toast.error('Please select a deal first');
      return;
    }
    const payload = {
      id: parseInt(templateId),
      deal_id: parseInt(selectedDealId),
      date: selectedDate // Use the selected date
    };
    createDocument(payload);
  };

  if (isLoadingCloseDeals) {
    return <div>Loading deals...</div>;
  }

  if (isErrorCloseDeals) {
    return <div>Failed to fetch deals. Please try again.</div>;
  }

  return (
    <div className="flex flex-col gap-6">
      {/* Deal Selection Dropdown */}
      <div>
        <label className="font-medium mb-2 block">Select a Deal</label>
        <select
          className="border rounded p-2 w-full"
          value={selectedDealId}
          onChange={(e) => setSelectedDealId(e.target.value)}>
          <option value="">-- Select Deal --</option>
          {dealsForProject.map((deal) => {
            const leadName = deal?.lead?.user?.name;
            const unitName = deal?.unit?.unitName;
            return (
              <option key={deal.id} value={deal.id}>
                {leadName} ({unitName})
              </option>
            );
          })}
        </select>
      </div>

      {/* Date Selection Section */}
      <div>
        <label className="font-medium mb-2 block">Select Date</label>
        <div className="flex items-center gap-4">
          <label>
            <input
              type="radio"
              value="current"
              checked={dateOption === 'current'}
              onChange={() => {
                setDateOption('current');
                setSelectedDate(new Date().toISOString().split('T')[0]);
              }}
            />
            Current Date
          </label>
          <label>
            <input
              type="radio"
              value="custom"
              checked={dateOption === 'custom'}
              onChange={() => setDateOption('custom')}
            />
            Custom Date
          </label>
        </div>
        {dateOption === 'custom' && (
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className="border rounded p-2 mt-2"
          />
        )}
      </div>

      {/* Footer Buttons */}
      <div className="flex justify-end gap-4 mt-4">
        <Button onClick={onClose} displayType="secondary">
          Cancel
        </Button>
        <Button onClick={handleGenerateDocument} disabled={isGeneratingDoc}>
          {isGeneratingDoc ? 'Generating...' : 'Generate'}
        </Button>
      </div>
    </div>
  );
};

export default NewPropertyDocumentModal;
